export default __webpack_public_path__ + "static/media/p.8eb79ab1.svg";